/** Origin handoff is optional evidence; Admin validates the referenced source records. */
export function resolveLandingPageConversionOrigin(input: {
  clientAccountId: string;
  campaignId: string;
  campaignParticipantId: string;
  url: string;
  storedOrigin: string | null;
}): string | undefined {
  const explicit = new URL(input.url, 'http://localhost').searchParams.get('buzzwaveConversionId');
  if (explicit) return explicit;
  try {
    const origin = JSON.parse(input.storedOrigin ?? 'null');
    // Generic landing pages cannot identify which registrant is sharing. They
    // require an explicit handoff; never borrow an anonymous tab's last origin.
    if (
      input.campaignParticipantId &&
      origin?.campaignParticipantId === input.campaignParticipantId &&
      origin.clientAccountId === input.clientAccountId &&
      origin.campaignId === input.campaignId &&
      typeof origin.conversionId === 'string' &&
      origin.conversionId
    )
      return origin.conversionId;
  } catch {
    /* No trustworthy handoff. */
  }
  return undefined;
}
